import { useQuery } from '@tanstack/react-query';
import { fetchQuizBySlug } from '@/lib/services/questions';
import type { QuizMetadata } from '@/types/quiz';

const fetchQuizMetadata = async (slug: string): Promise<QuizMetadata | null> => {
  try {
    return (await fetchQuizBySlug(slug)) as QuizMetadata | null;
  } catch (error) {
    console.error('❌ Error fetching quiz metadata', error);
    throw error;
  }
};

export function useQuizMetadataQuery(
  slug?: string,
  options?: { initialData?: QuizMetadata | null }
) {
  return useQuery<QuizMetadata | null>({
    queryKey: ['quizMetadata', slug],
    queryFn: () => fetchQuizMetadata(slug as string),
    enabled: !!slug,
    initialData: options?.initialData,
    staleTime: 1000 * 60 * 5,
  });
}
